//DEPENDENCIES
import React, { useContext, useMemo } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { SETTINGS } from 'pathnames.js';

// GLOBAL FUNCITONS
import { makePath } from 'functions';

// GLOBAL HELPERS
import { getListData, ListContext } from 'helpers/getListData';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL COMPONENTS
import ExcelButtons from 'routers/interface/tools/ExcelButtons';

// MAIN COMPONENT
const Staff = () => {
  // CONTEXT
  const { result } = useContext(ListContext) || {};

  // MEMOS
  const sortedResult = useMemo(
    () =>
      result?.map(({ title, users }) => ({
        title: title,
        data: users
      })),
    [result]
  );

  // RENDER
  return (
    <Main>
      <Title title="Staff" tools={<ExcelButtons fileName="staff" />} />
      <Filters>
        <Filters.Search name="q" placeholder="Search by name" />
      </Filters>
      <Table.Sorted sortedResult={sortedResult} mobilePreviewKeys={['first_name', 'last_name']} />
    </Main>
  );
};

// EXPORT
export default getListData(Staff, {
  key: 'staff',
  path: makePath(SETTINGS.staff),
  fetchArgs: {
    endpoint: ENDPOINTS.admin.staff.list
  },
  defaults: {
    startRow: null
  },
  columns: [
    {
      key: 'first_name',
      label: 'First Name',
      width: 100
    },
    {
      key: 'last_name',
      label: 'Last Name',
      width: 100
    },
    {
      key: 'cell_phone_number',
      label: 'Cell',
      width: 80
    },
    {
      key: 'email_address',
      label: 'Email'
    },
    {
      key: 'last_login_date',
      label: 'Last Login',
      width: 100,
      component: Table.DateTime
    }
  ]
});
